<template>
  <ValidationObserver
    ref="dialogObserver"
    v-slot="{ valid }"
    slim="slim"
  >
    <AppDialog
      class="overtime-policy-dialog"
      :title="`Set pay rate for ${member.name}`"
      append-to-body="append-to-body"
      show="show"
      @close="closePayDialog"
    >
      <form
        id="member-pay-form"
        autocomplete="off"
        @submit.prevent="onFormSubmit"
      >
        <ValidationProvider
          ref="nameProvider"
          rules="required"
          :name="form.pay_rate"
        >
          <div
            id="pay_rate"
            class="form-group mb-10"
            :class="{ 'has-error': fieldError('pay_rate') }"
          >
            <label
              class="control-label"
              for="pay_rate"
            >
              Pay rate
              <abbr title="required">*</abbr>
            </label>
            <div class="input-group">
              <AppInput
                v-model="form.pay_rate"
                class="form-control"
                placeholder="Pay rate"
                required="required"
              />
              <span class="input-group-addon"> {{ organization.currency }}/hr </span>
            </div>
            <span
              v-show="fieldError('pay_rate')"
              class="help-block"
            >
              {{ fieldError('pay_rate') }}
            </span>
          </div>
        </ValidationProvider>
      </form>

      <template #footer>
        <AppButton
          type="default"
          @click="closePayDialog"
        >
          Cancel
        </AppButton>
        <button
          class="btn btn-primary"
          type="submit"
          form="member-pay-form"
          :disabled="!valid || form.processing"
        >
          Save
        </button>
      </template>
    </AppDialog>
  </ValidationObserver>
</template>
<script>
import { mapInertiaProps } from '~/utils/inertia';
import { applyTemplate } from '~/utils/url_template';

export default {
  name: 'OvertimePoliciesMemberPayDialog',
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBillRateField: false,
      form: this.$inertia.form({
        pay_rate: this.member.pay_rate,
      }),
    };
  },
  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
  },
  methods: {
    closePayDialog() {
      this.$emit('close');
    },
    fieldError(field) {
      if (this.form.errors && this.form.errors[field]) {
        return this.form.errors[field][0];
      }
    },
    onFormSubmit() {
      const { origin } = window.location;
      const memberUrl = '/user_organizations/:id';
      const url = new URL(applyTemplate(`${memberUrl}`, { id: this.member.id }), origin);
      const memberUrlString = url.toString();

      this.form.transform((data) => {
        const payload = {};

        payload.pay_rate = data.pay_rate;

        return { user_organization: { payment: payload }, id: this.member.id };
      });

      const options = { onSuccess: () => this.closePayDialog() };

      return this.form.patch(memberUrlString, options);
    },
  },
};
</script>
